import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";

export const useTableData = () => {
  const commonCellStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const columns: ColGroupDef[] = [
    {
      headerName: "Slag",
      children: [
        {
          field: "Time",
          headerName: "Time",
          flex: 1,
          valueGetter: (params: any) => {
            if (params.data.Time) {
              return dxtToLocalServerTime(params.data.Time, "HH:mm");
            }
          },
        },
        {
          field: "FeO",
          headerName: "FeO",
          flex: 1,
        },
        {
          field: "MnO",
          headerName: "MnO",
          flex: 1,
        },
        {
          field: "CaO",
          headerName: "CaO",
          flex: 1,
        },
        {
          field: "MgO",
          headerName: "MgO",
          flex: 1,
        },
        {
          field: "SiO2",
          headerName: "SiO2",
          flex: 1,
        },
        {
          field: "Al2O3",
          headerName: "Al2O3",
          flex: 1,
        },
        {
          field: "Cr2O3",
          headerName: "Cr2O3",
          flex: 1,
        },
        {
          field: "TiO2",
          headerName: "TiO2",
          flex: 1,
        },
        {
          field: "P2O5",
          headerName: "P2O5",
          flex: 1,
        },
        {
          field: "SO3",
          headerName: "SO3",
          flex: 1,
        },
        {
          field: "B3",
          headerName: "B3",
          flex: 1,
        },
      ],
    },
  ];

  return { columns };
};
